import { alpha, Box, Container, Typography } from "@mui/material";
import { HomeBg } from "assets";
import theme, { responsiveFontSize } from "themes/Theme";
import SecondaryButton from "components/SecondaryButton/SecondaryButton";
import { useNavigate } from "react-router-dom";

const HeroSection = () => {
  const navigate = useNavigate();
  return (
    <Box sx={styles.heroContainer}>
      <Container sx={{ py: 8 }}>
        <Typography sx={styles.heroSectionTitle}>
          Secure. Green. Fast. <br />
          Carbon Wallet.
        </Typography>
        <Typography sx={styles.heroSectionDescription}>
          Send and receive Emission Reduction Coins with blockchain-powered
          trust and transparency.
        </Typography>
        <center>
          <SecondaryButton
            onClick={() => {
              navigate("/auth/login");
            }}
            title="Get Started Now"
          />
        </center>
      </Container>
    </Box>
  );
};

export default HeroSection;
const styles = {
  heroContainer: {
    backgroundImage: `url(${HomeBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderBottomLeftRadius: "50px",
    borderBottomRightRadius: "50px",
    overflow: "hidden",
    width: "100vw",
  },
  heroSectionTitle: {
    fontSize: responsiveFontSize(75),
    fontWeight: 400,
    color: theme.palette.custom.white,
    textAlign: "center",
    lineHeight: { xs: 1.2, md: 1.5 },
    marginTop: "1em",
  },
  heroSectionDescription: {
    fontSize: responsiveFontSize(15),
    fontWeight: 400,
    color: theme.palette.custom.white,
    textAlign: "center",
    marginTop: "3em",
    marginBottom: "3em",
  },
  checkNowBtn: {
    backgroundColor: theme.palette.secondary?.main,
    borderRadius: "3em",
  },
  checkNowText: {
    fontWeight: 400,
    fontSize: responsiveFontSize(16),
    textTransform: "Capitalize",
    color: theme.palette.primary.main,
  },
};
